import React, { Component } from 'react';
import AdminFunctions from '../admin/AdminFunctions';
import AccountFunctions from '../services/AccountService';
import { Container, Row, Col, Input, Button } from 'reactstrap';
import '../layout/site.css';
import Modal from 'react-bootstrap/Modal';
import AuthFunctions from '../services/AuthService';

export class AccountDetails extends Component {
    static displayName = AccountDetails.name;

    constructor(props) {
        super(props);

        this.state = {
            stateList: [],
            client: null,
            Account: { notes: [] },
            OriginalAccount: { notes: [] },
            Modified: {},
            Accounts: [],
            sites: [],
            isAdmin: false,
            height: 0,
            width: 0,
            sort: {
                column: null,
                direction: 'desc'
            },
            showToast: false,
            loading: false,
            noResults: false,
            currentPage: 1,
            itemsPerPage: 100,
            numberOfPages: 0,
            districtDefault: {},
            shippingSame: false,
            showToast: false,
            creditCard: false,
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleCreditCardChange = this.handleCreditCardChange.bind(this);
        this.handleAddressChange = this.handleAddressChange.bind(this);
        this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
        this.requestEmail = this.requestEmail.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.formChanged = this.formChanged.bind(this);
        this.valueChanged = this.valueChanged.bind(this);

        window.addEventListener('resize', this.setWindowDimensions);
        //document.getElementsByTagName('html')[0].className = "background-ring";
        this.checkAuthenticated();
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        if (!isAuthenticated) {
            this.props.history.push('/login');
        }
    }

    valueChanged(field, value) {
        var account = this.state.Account;
        var modified = this.state.Modified;
        account[field] = value;
        modified[field] = (value !== this.state.OriginalAccount[field]);
        this.setState({ Account: account, Modified: modified });
        this.formChanged();
    }

    formChanged() {
        return JSON.stringify(this.state.Account) !== JSON.stringify(this.state.OriginalAccount);
    }

    handleClose() {
        this.setState({ showToast: false });
    }

    async handleCreditCardChange() {
        var useCC = !this.state.creditCard;

        this.setState({ creditCard: useCC });

        if (useCC) {
            const formData = new FormData();

            formData.append('CreditCard', useCC);

            var response = await AccountFunctions.postAccountCreditCardAsync(formData);

            if (response != null) {
                this.setState({ modalTitle: 'Email Sent!' });
                this.setState({ modalBody: (<div>Thank you for contacting <span style={{ color: '#233c7c', fontWeight: 'bold' }}>TICMS</span>, your request for CC payment has been sent for our review!</div>) });

                this.setState({ showToast: true });
            }

        }
    }

    async requestEmail() {
        if (this.formChanged()) {
            var dto = {
                updated: this.state.Account,
                original: this.state.OriginalAccount
            };

            var response = await AccountFunctions.postAccountUpdateAsync(dto);

            if (response != null) {
                this.setState({ modalTitle: 'Email Sent!' });
                this.setState({ modalBody: (<div>Thank you for providing <span style={{ color: '#233c7c', fontWeight: 'bold' }}>TICMS</span> with your customer account update.The <span style={{ color: '#233c7c', fontWeight: 'bold' }}>TICMS</span> team will take care of this for you.<br /> <br />Have a great day.</div>) });
                this.setState({ showToast: true });
            }
        } else {
            this.setState({ modalTitle: 'No Changes!' });
            this.setState({ modalBody: 'No changes were detected.  If you wish to submit a request for an update, please modify your Account information and try again.' });
            this.setState({ showToast: true });
        }
    };

    async handleSubmission(fileData) {
        const formData = new FormData();

        formData.append('File', fileData);
        formData.append('CreditCard', this.state.creditCard);
        formData.append('PONo', this.state.Account.billToPO);

        var response = await AccountFunctions.postAccountUploadAsync(formData);

        if (response != null) {
            this.setState({ modalTitle: 'Email Sent!' });
            this.setState({ modalBody: (<div>Thank you for contacting <span style={{ color: '#233c7c', fontWeight: 'bold' }}>TICMS</span>, your file has been sent for our review!</div>) });

            this.setState({ showToast: true });
        }
    };

    handleClick(event) {
        let id = Number(event.target.id);

        if (id === 0) {
            this.setState({
                currentPage: 1
            });
        } else if (id === -1) {
            this.setState({
                currentPage: Math.ceil(this.state.sites.length / this.state.itemsPerPage)
            });
        } else {
            this.setState({
                currentPage: Number(event.target.id)
            });
        }
    }

    handleAddressChange(event) {
        if (event.target.checked) {
            var tempCompany = this.state.Account;
            tempCompany.shipToAddress1 = tempCompany.customerAddress1;
            tempCompany.shipToAddress2 = tempCompany.customerAddress2;
            tempCompany.shipToCity = tempCompany.customerCity;
            tempCompany.shipToState = tempCompany.customerState;
            tempCompany.shipToZip = tempCompany.customerZip;

            this.setState({ Account: tempCompany });
        }

        this.setState({ shippingSame: event.target.checked });
    }

    handleChange(event) {
        this.setState({ currentPage: Number(event.target.value) });
    }

    handlePageSizeChange(event) {
        let pageSize = Number(event.target.value);
        this.setState({ itemsPerPage: pageSize });
        if (this.state.currentPage > Math.ceil(this.state.sites.length / pageSize)) {
            this.setState({ currentPage: Math.ceil(this.state.sites.length / pageSize) })
        }
    }

    async componentDidMount() {
        document.getElementsByTagName('html')[0].className = "";

        this.setWindowDimensions();
        const isAdmin = await AdminFunctions.isAdminAsync();
        this.setState({ isAdmin: isAdmin });
        if (isAdmin) {

        }
        else {
        }

        this.getAccountData();
    }

    async getAccountData() {
        var account = await AccountFunctions.getAccountAsync();

        if (account.success == true) {
            if (account.data != null) {
                var data = account.data;
                if (data.customerAddress1 === data.shipToAddress1 && data.customerAddress2 == data.shipToAddress2 && data.customerCity === data.shipToCity && data.customerState === data.shipToState && data.customerZip === data.shipToZip) {
                    this.setState({ shippingSame: true });
                    data.shippingSame = true;
                } else {
                    this.setState({ shippingSame: false });
                    data.shippingSame = false;
                }
                var original = JSON.parse(JSON.stringify(data));

                this.setState({ Account: data, OriginalAccount: original });
            }
        }
    }

    setWindowDimensions = () => {
        this.setState({
            height: window.innerHeight,
            width: window.innerWidth
        });
    };

    render() {
        //Put in logic here! 

        return (
            <div>
                <Container>
                    <Row>
                        <Col>
                            <h2 style={{ color: '#233c7c' }}>Account Information</h2>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <h3>Company Information</h3>
                        </Col>
                        <Col>
                            <h3>Customer Courier Information</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col xl='6' lg='6' md='6' sm='12' xs='12'>
                            <Input
                                type='text'
                                name='TIC #'
                                id='name'
                                readOnly={true}
                                className='smallInput'
                                placeholder='TIC #'
                                value={this.state.Account.ticNo}
                            />
                            <Input
                                type='text'
                                onChange={(e) => {
                                    this.valueChanged('customerName', e.target.value);
                                }}
                                className={this.state.Modified.customerName ? 'normalInput modifiedInput' : 'normalInput'}
                                name='CustomerNameC'
                                id='CustomerNameC'
                                placeholder='Customer Name'
                                value={this.state.Account.customerName}
                            />
                            <Input
                                type='text'
                                onChange={(e) => {
                                    this.valueChanged('customerAddress1', e.target.value);
                                }}
                                className={this.state.Modified.customerAddress1 ? 'normalInput modifiedInput' : 'normalInput'}
                                name='Address1C'
                                id='Address1C'
                                placeholder='Address 1'
                                value={this.state.Account.customerAddress1}
                            />
                            <Input
                                type='text'
                                onChange={(e) => {
                                    this.valueChanged('customerAddress2', e.target.value);
                                }}
                                className={this.state.Modified.customerAddress2 ? 'normalInput modifiedInput' : 'normalInput'}
                                name='Address2C'
                                id='Address2C'
                                placeholder='Address 2'
                                value={this.state.Account.customerAddress2}
                            />
                            <Input
                                type='text'
                                onChange={(e) => {
                                    this.valueChanged('customerCity', e.target.value);
                                }}
                                className={this.state.Modified.customerCity ? 'normalInput modifiedInput' : 'normalInput'}
                                name='CityC'
                                id='CityC'
                                placeholder='City'
                                value={this.state.Account.customerCity}
                            />
                            <Row className="mediumSize">
                                <Col>
                                    <Input
                                        type='text'
                                        onChange={(e) => {
                                            this.valueChanged('customerState', e.target.value);
                                        }}
                                        className={this.state.Modified.customerState ? 'normalInput modifiedInput' : 'normalInput'}
                                        name='StateC'
                                        maxLength={2}
                                        id='StateC'
                                        placeholder='State'
                                        value={this.state.Account.customerState}
                                    />
                                </Col>
                                <Col>
                                    <Input
                                        type='text'
                                        onChange={(e) => {
                                            this.valueChanged('customerZip', e.target.value);
                                        }}
                                        className={this.state.Modified.customerZip ? 'normalInput modifiedInput' : 'normalInput'}
                                        name='Zipc'
                                        id='ZipC'
                                        placeholder='Zip'
                                        value={this.state.Account.customerZip}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <h3>Shipping Address</h3>
                                </Col>
                                <Col className="centerItem">
                                    <Input
                                        type='checkbox'
                                        name='ShippingSame'
                                        id='ShippingSame'
                                        onChange={(e) => this.handleAddressChange(e)}
                                        placeholder='ShippingSame'
                                        value={this.state.shippingSame}
                                    /> <span className='subText'> Same as Company Information</span>
                                </Col>
                            </Row>
                            <Input
                                type='text'
                                onChange={(e) => {
                                    this.valueChanged('shipToAddress1', e.target.value);
                                }}
                                className={this.state.Modified.shipToAddress1 ? 'normalInput modifiedInput' : 'normalInput'}
                                name='Address1S'
                                id='Address1S'
                                placeholder='Address 1'
                                readOnly={this.state.shippingSame}
                                value={this.state.Account.shipToAddress1}
                            />
                            <Input
                                type='text'
                                onChange={(e) => {
                                    this.valueChanged('shipToAddress2', e.target.value);
                                }}
                                className={this.state.Modified.shipToAddress2 ? 'normalInput modifiedInput' : 'normalInput'}
                                name='Address2S'
                                id='Address2S'
                                placeholder='Address 2'
                                readOnly={this.state.shippingSame}
                                value={this.state.Account.shipToAddress2}
                            />
                            <Input
                                type='text'
                                onChange={(e) => {
                                    this.valueChanged('shipToCity', e.target.value);
                                }}
                                className={this.state.Modified.shipToCity ? 'normalInput modifiedInput' : 'normalInput'}
                                name='CityC'
                                id='CityC'
                                placeholder='City'
                                readOnly={this.state.shippingSame}
                                value={this.state.Account.shipToCity}
                            />
                            <Row className="mediumSize">
                                <Col>
                                    <Input
                                        type='text'
                                        onChange={(e) => {
                                            this.valueChanged('shipToState', e.target.value);
                                        }}
                                        className={this.state.Modified.shipToState ? 'normalInput modifiedInput' : 'normalInput'}
                                        name='StateC'
                                        maxLength={2}
                                        id='StateC'
                                        placeholder='State'
                                        readOnly={this.state.shippingSame}
                                        value={this.state.Account.shipToState}
                                    />
                                </Col>
                                <Col>
                                    <Input
                                        type='text'
                                        onChange={(e) => {
                                            this.valueChanged('shipToZip', e.target.value);
                                        }}
                                        className={this.state.Modified.shipToZip ? 'normalInput modifiedInput' : 'normalInput'}
                                        name='Zipc'
                                        id='ZipC'
                                        placeholder='Zip'
                                        readOnly={this.state.shippingSame}
                                        value={this.state.Account.shipToZip}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <h3>Quality Contact</h3>
                                </Col>
                                <Col className="centerItem subText">
                                    <span> (This contact will appear on the certification)</span>
                                </Col>
                            </Row>
                            <Input
                                type='text'
                                onChange={(e) => {
                                    this.valueChanged('qcName', e.target.value);
                                }}
                                className={this.state.Modified.qcName ? 'normalInput modifiedInput' : 'normalInput'}
                                name='FirstNameLastNameQ'
                                id='FirstNameLastNameQ'
                                placeholder='First Name Last Name'
                                value={this.state.Account.qcName}
                            />
                            <Row className="mediumSize">
                                <Col>
                                    <Input
                                        type='text'
                                        onChange={(e) => {
                                            this.valueChanged('qcPhone', e.target.value);
                                        }}
                                        className={this.state.Modified.qcPhone ? 'normalInput modifiedInput' : 'normalInput'}
                                        name='OfficePhone'
                                        id='OfficePhone'
                                        placeholder='Office Phone'
                                        value={this.state.Account.qcPhone}
                                    />
                                </Col>
                                <Col>
                                    <Input
                                        type='text'
                                        onChange={(e) => {
                                            this.valueChanged('qcExt', e.target.value);
                                        }}
                                        className={this.state.Modified.qcExt ? 'normalInput modifiedInput' : 'normalInput'}
                                        name='Ext'
                                        id='Ext'
                                        placeholder='Ext.'
                                        value={this.state.Account.qcExt}
                                    />
                                </Col>
                            </Row>
                            <Input
                                type='text'
                                onChange={(e) => {
                                    this.valueChanged('qcEmail', e.target.value);
                                }}
                                className={this.state.Modified.qcEmail ? 'normalInput modifiedInput' : 'normalInput'}
                                name='EmailQ'
                                id='EmailQ'
                                placeholder='Email'
                                value={this.state.Account.qcEmail}
                            />
                        </Col>
                        <Col xl='6' lg='6' md='6' sm='12' xs='12'>
                            <Input
                                type='text'
                                onChange={(e) => {
                                    this.valueChanged('courierAccountNo', e.target.value);
                                }}
                                className={this.state.Modified.courierAccountNo ? 'normalInput modifiedInput' : 'normalInput'}
                                name='Acc #'
                                id='name'
                                placeholder='Acc #'
                                value={this.state.Account.courierAccountNo}
                            />
                            <Row>
                                <Col>
                                    <Input
                                        type='text'
                                        onChange={(e) => {
                                            this.valueChanged('courierName', e.target.value);
                                        }}
                                        className={this.state.Modified.courierName ? 'normalInput modifiedInput' : 'normalInput'}
                                        name='Courier'
                                        id='name'
                                        placeholder='Courier'
                                        value={this.state.Account.courierName}
                                    />
                                </Col>
                                <Col>
                                    <span className="subText">(FedEx Accounts will have an additional surcharge that will apply) </span>
                                </Col>
                            </Row>
                            <Input
                                type='text'
                                onChange={(e) => {
                                    this.valueChanged('courierInstructions', e.target.value);
                                }}
                                className={this.state.Modified.courierInstructions ? 'normalInput modifiedInput' : 'normalInput'}
                                name='Special Instructions'
                                id='name'
                                placeholder='Special Instructions'
                                value={this.state.Account.courierInstructions}
                            />
                            <h3>Billing Address</h3>

                            <Input
                                type='text'
                                onChange={(e) => {
                                    this.valueChanged('billToName', e.target.value);
                                }}
                                className={this.state.Modified.billToName ? 'normalInput modifiedInput' : 'normalInput'}
                                name='Courier'
                                id='name'
                                placeholder='Bill To'
                                value={this.state.Account.billToName}
                            />


                            <Row>
                                <Col>
                                    <Input
                                        type='text'
                                        onChange={(e) => {
                                            this.valueChanged('billToPO', e.target.value);
                                        }}
                                        className={this.state.Modified.billToPO ? 'normalInput modifiedInput' : 'normalInput'}
                                        name='PO #'
                                        id='name'
                                        placeholder='PO #'
                                        value={this.state.Account.billToPO}
                                    />
                                </Col>
                                <Col className="centerItem">
                                    <div className="fileInput">
                                        <Input
                                            type='file'
                                            name='fileUpload'
                                            id='fileUpload'
                                            accept=".pdf"
                                            onChange={(e) => { this.handleSubmission(e.target.files[0]) }}
                                            className='hideFileInput normalInput'
                                            placeholder='Upload'
                                        />
                                    </div>
                                </Col>
                                <Col className="centerItem">
                                    <Input
                                        type='checkbox'
                                        name='Courier'
                                        id='name'
                                        onChange={() => this.handleCreditCardChange()}
                                        value={this.state.creditCard}
                                        placeholder='Courier'
                                    /> <span className='subText'> Pay By Credit Card </span>
                                </Col>
                            </Row>
                            <Input
                                type='text'
                                onChange={(e) => {
                                    this.valueChanged('billToAddress1', e.target.value);
                                }}
                                className={this.state.Modified.billToAddress1 ? 'normalInput modifiedInput' : 'normalInput'}
                                name='Address1'
                                id='Address1'
                                placeholder='Address 1'
                                value={this.state.Account.billToAddress1}
                            />
                            <Input
                                type='text'
                                onChange={(e) => {
                                    this.valueChanged('billToAddress2', e.target.value);
                                }}
                                className={this.state.Modified.billToAddress2 ? 'normalInput modifiedInput' : 'normalInput'}
                                name='Address2'
                                id='Address2'
                                placeholder='Address 2'
                                value={this.state.Account.billToAddress2}
                            />
                            <Input
                                type='text'
                                onChange={(e) => {
                                    this.valueChanged('billToCity', e.target.value);
                                }}
                                className={this.state.Modified.billToCity ? 'normalInput modifiedInput' : 'normalInput'}
                                name='City'
                                id='City'
                                placeholder='City'
                                value={this.state.Account.billToCity}
                            />
                            <Row className="mediumSize">
                                <Col>
                                    <Input
                                        type='text'
                                        onChange={(e) => {
                                            this.valueChanged('billToState', e.target.value);
                                        }}
                                        className={this.state.Modified.billToState ? 'normalInput modifiedInput' : 'normalInput'}
                                        name='State'
                                        maxLength={2}
                                        id='State'
                                        placeholder='State'
                                        value={this.state.Account.billToState}
                                    />
                                </Col>
                                <Col>
                                    <Input
                                        type='text'
                                        onChange={(e) => {
                                            this.valueChanged('billToZip', e.target.value);
                                        }}
                                        className={this.state.Modified.billToZip ? 'normalInput modifiedInput' : 'normalInput'}
                                        name='Zip'
                                        id='Zip'
                                        placeholder='Zip'
                                        value={this.state.Account.billToZip}
                                    />
                                </Col>
                            </Row>
                            <Input
                                type='text'
                                onChange={(e) => {
                                    this.valueChanged('billToEmail', e.target.value);
                                }}
                                className={this.state.Modified.billToEmail ? 'normalInput modifiedInput' : 'normalInput'}
                                name='Email'
                                id='BillEmail'
                                placeholder='Email'
                                value={this.state.Account.billToEmail}
                            />
                            <Input
                                type='text'
                                name='FirstLastName'
                                id='FirstLastName'
                                className='normalInput'
                                placeholder='First Name_Last Name'
                            />
                            <h3>Secondary Quality Contact</h3>
                            <Input
                                type='text'
                                onChange={(e) => {
                                    this.valueChanged('qc2Name', e.target.value);
                                }}
                                className={this.state.Modified.qc2Name ? 'normalInput modifiedInput' : 'normalInput'}
                                name='FirstLastNameSQC'
                                id='FirstLastNameSQC'
                                placeholder='First Name_Last Name'
                                value={this.state.Account.qc2Name}
                            />
                            <Row className="mediumSize">
                                <Col>
                                    <Input
                                        type='text'
                                        onChange={(e) => {
                                            this.valueChanged('qc2Phone', e.target.value);
                                        }}
                                        className={this.state.Modified.qc2Phone ? 'normalInput modifiedInput' : 'normalInput'}
                                        name='OfficePhone'
                                        id='OfficePhone'
                                        placeholder='Office Phone'
                                        value={this.state.Account.qc2Phone}
                                    />
                                </Col>
                                <Col>
                                    <Input
                                        type='text'
                                        onChange={(e) => {
                                            this.valueChanged('qc2Ext', e.target.value);
                                        }}
                                        className={this.state.Modified.qc2Ext ? 'normalInput modifiedInput' : 'normalInput'}
                                        name='Ext'
                                        id='Ext'
                                        placeholder='Ext.'
                                        value={this.state.Account.qc2Ext}
                                    />
                                </Col>
                            </Row>
                            <Input
                                type='text'
                                onChange={(e) => {
                                    this.valueChanged('qc2Email', e.target.value);
                                }}
                                className={this.state.Modified.qc2Email ? 'normalInput modifiedInput' : 'normalInput'}
                                name='EmailSQC'
                                id='EmailSQC'
                                placeholder='Email'
                                value={this.state.Account.qc2Email}
                            />
                        </Col>
                        <Col xl='6' lg='6' md='6' sm='12' xs='12' className='buttonCol text-right'>
                            <Button color='primary' className='button normalInput' onClick={() => this.requestEmail()}>
                                Request Data Update
                            </Button>
                        </Col>
                    </Row>
                    <Modal show={this.state.showToast} onHide={this.handleClose}>
                        <Modal.Header >
                            <Modal.Title>{this.state.modalTitle}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {this.state.modalBody}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button className='standardButton btn btn-primary' onClick={this.handleClose}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </Container>
            </div>
        )
    }
 }